module.exports = __webpack_public_path__ + "static/media/ZTDC02.8072eb80.jpg";